/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.branding.getBranding";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"broadcaster":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"did"}))});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"assets":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<BrandingAsset>((() => brandingAsset) as any), )});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get all branding configuration for the broadcaster. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;

type BrandingAsset = { $type?: "place.stream.branding.getBranding#brandingAsset";

  /**
   * Asset key identifier
   */
  "key":string;

  /**
   * MIME type of the asset
   */
  "mimeType":string;

  /**
   * URL to fetch the asset blob (for images)
   */
  "url"?:string;

  /**
   * Inline data for text assets
   */
  "data"?:string;

  /**
   * Image width in pixels (optional, for images only)
   */
  "width"?:number;

  /**
   * Image height in pixels (optional, for images only)
   */
  "height"?:number };

export type { BrandingAsset };

const brandingAsset = /*#__PURE__*/ l.typedObject<BrandingAsset>($nsid, "brandingAsset", /*#__PURE__*/ l.object({"key":/*#__PURE__*/ l.string(),"mimeType":/*#__PURE__*/ l.string(),"url":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"data":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"width":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"height":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer())}));

export { brandingAsset };
